var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dateNow"},[_c('small',{staticClass:"dateNowText"},[_vm._v(" "+_vm._s(_vm.today)+" ")]),_c('small',{staticClass:"dateNowTextTime"},[_vm._v(" "+_vm._s(_vm.time)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }